<template>
  <transition
    mode="out-in"
    @enter="enter"
    @leave="leave"
  >
    <slot />
  </transition>
</template>

 <script>
  import { gsap } from 'gsap'

   export default {
     methods: {
       enter(el, done) {

          const pageIn = gsap.timeline({
             paused: true,
             defaults: {
               duration: 1.2,
               ease: 'power3.out',
               clearProps: 'opacity'
             },
             onComplete: () => {
               done()
             }
           })

           pageIn.from(el, { opacity: 0 });
           pageIn.play();

        },
        leave(el, done) {

          const pageOut = gsap.timeline({
             paused: true,
             defaults: {
               duration: 0.2,
               ease: 'power3.inOut'
             },
             onComplete: () => {
               window.scrollTo(0,0)
               done()
             }
           })

           pageOut.to(el, { opacity: 0 });
           pageOut.play();

        }
     }
   }
 </script>
